<!-- 关于我们-公司介绍-里程碑 -->
<template>
	<div class="Milestone-warp">
		<div class="milestone" v-lazy:background-image="milestoneSrc">
			<div class="milestone-center">
				<div class="milestone-inner">
					<div class="milestone-inner-title">公司发展历程</div>
					<div class="timeline-list">
						<!-- 未来：固定内容，无 title / li -->
						<div class="timeline-item is-future">
							<div class="timeline-time">未来</div>
							<div class="timeline-axis">
								<span class="timeline-node"></span>
								<span class="timeline-line"></span>
							</div>
							<div class="timeline-card">
								<p class="timeline-card-text">
									智启未来，征途浩瀚。让我们携手，共赴产业智能化的星辰大海
								</p>
							</div>
						</div>
						<div
							class="timeline-item"
							v-for="(item, index) in milestoneList"
							:key="index"
						>
							<div class="timeline-time">
								<template v-if="isYearRange(item.timestamp)">
									<span
										>{{
											yearParts(item.timestamp)[0]
										}}-</span
									><br class="timeline-br" /><span>{{
										yearParts(item.timestamp)[1]
									}}</span>
								</template>
								<template v-else>{{ item.timestamp }}</template>
							</div>
							<div class="timeline-axis">
								<span class="timeline-node"></span>
								<span
									class="timeline-line"
									v-if="index < milestoneList.length - 1"
								></span>
							</div>
							<div class="timeline-card">
								<div class="timeline-card-title">
									{{ item.title }}
								</div>
								<ul class="timeline-card-content">
									<li
										v-for="(text, cIndex) in item.content"
										:key="cIndex"
									>
										{{ text }}
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { companyMilestoneList } from './mock'
export default {
	name: 'Milestone',
	data() {
		return {
			milestoneList: companyMilestoneList,
			milestoneSrc: require('@/assets/img/company/course.png'),
		}
	},
	methods: {
		isYearRange(timestamp) {
			return String(timestamp).includes('-')
		},
		yearParts(timestamp) {
			return String(timestamp).split('-')
		},
	},
}
</script>
<style lang="scss" scoped>
.Milestone-warp {
	.milestone {
		width: 100%;
		min-height: 1100px;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center center;
		background-color: #f5f9ff;

		&-center {
			width: 100%;
		}

		&-inner {
			margin: 0 var(--page-gutter);
			padding: 95px 0 100px;
			box-sizing: border-box;

			&-title {
				font-size: 52px;
				font-family: 'PingFang SC', 'Source Han Sans SC';
				font-weight: 700;
				color: #333333;
				line-height: 60px;
				margin-bottom: 50px;
			}
		}

		.timeline-list {
			display: flex;
			flex-direction: column;
		}

		.timeline-item {
			display: flex;
			align-items: flex-start;
			position: relative;

			& + .timeline-item {
				margin-top: 28px;
			}
		}

		.timeline-time {
			width: 148px;
			flex-shrink: 0;
			font-size: 22px;
			font-family: 'PingFang SC', 'Source Han Sans SC';
			font-weight: 600;
			color: #127bf2;
			line-height: 32px;
			text-align: right;
			/* 与卡片 padding-top 24px 对齐；行高 32 与 10px 圆点垂直居中 */
			padding-top: 24px;
			padding-right: 24px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			white-space: nowrap;

			.timeline-br {
				display: none;
			}
		}

		.timeline-axis {
			position: relative;
			flex-shrink: 0;
			align-self: stretch;
			width: 16px;
			/* 24 + (32 - 10) / 2 = 35，圆点中心与时间文字中心对齐 */
			padding-top: 35px;
		}

		.timeline-node {
			display: block;
			width: 10px;
			height: 10px;
			border-radius: 50%;
			background-color: #2d7eff;
			position: relative;
			z-index: 2;
			margin: 0 auto;
			box-shadow: 0 0 0 5px rgba(45, 126, 255, 0.1);
		}

		.timeline-line {
			display: block;
			width: 2px;
			background-color: rgba(233, 235, 239, 1);
			position: absolute;
			/* 圆点中心：35 + 5 = 40 */
			top: 40px;
			bottom: -68px;
			left: 50%;
			transform: translateX(-50%);
			z-index: 1;
		}

		.timeline-card {
			flex: 1;
			min-width: 0;
			margin-left: 28px;
			background: #ffffff;
			border-radius: 12px;
			box-shadow: 0 4px 16px rgba(18, 123, 242, 0.08);
			padding: 24px 32px;
			box-sizing: border-box;

			&-title {
				font-size: 24px;
				font-family: 'PingFang SC', 'Source Han Sans SC';
				font-weight: 500;
				color: #333333;
				line-height: 34px;
				margin-bottom: 12px;
			}

			&-content {
				margin: 0;
				padding: 0;
				list-style: none;

				li {
					position: relative;
					padding-left: 18px;
					font-size: 16px;
					font-family: 'PingFang SC', 'Source Han Sans SC';
					font-weight: 400;
					line-height: 30px;
					color: #5e6172;

					& + li {
						margin-top: 0;
					}

					&::before {
						content: '';
						position: absolute;
						left: 0;
						top: 12px;
						width: 6px;
						height: 6px;
						border-radius: 50%;
						background-color: #5e6172;
					}
				}
			}

			&-text {
				margin: 0;
				font-size: 16px;
				font-family: 'PingFang SC', 'Source Han Sans SC';
				font-weight: 400;
				color: #666666;
				line-height: 28px;
			}
		}

		.timeline-item.is-future {
			.timeline-card {
				display: flex;
				align-items: center;
				min-height: 72px;
				padding: 20px 32px;
			}
		}
	}
}

@media screen and (max-width: 768px) {
	.Milestone-warp {
		.milestone {
			min-height: auto;
			background-size: cover;
			background-position: center top;

			&-inner {
				margin: 0 8px;
				padding: 24px 8px 32px;

				&-title {
					font-size: 20px;
					line-height: 28px;
					margin-bottom: 16px;
					color: #333333;
					padding: 0 12px;
				}
			}

			.timeline-item {
				& + .timeline-item {
					margin-top: 12px;
				}
			}

			.timeline-time {
				width: auto;
				min-width: 74px;
				padding-top: 9px;
				padding-right: 6px;
				font-size: 12px;
				font-weight: 600;
				line-height: 16px;
				text-align: right;
				display: flex;
				align-items: center;
				justify-content: flex-end;
				/* 移动端时间不换行，如 2024-2026 */
				white-space: nowrap;

				.timeline-br {
					display: none;
				}
			}

			.timeline-axis {
				position: relative;
				align-self: stretch;
				width: 8px;
				/* 12 + (16 - 10) / 2 = 15，与时间文字垂直居中 */
				padding-top: 15px;
			}

			.timeline-node {
				width: 5px;
				height: 5px;
				box-shadow: 0 0 0 2.5px rgba(45, 126, 255, 0.1);
			}

			.timeline-line {
				/* 圆点中心：15 + 5 = 20 */
				top: 20px;
				bottom: -32px;
				width: 2px;
				background-color: rgba(233, 235, 239, 1);
			}

			.timeline-card {
				margin-left: 8px;
				border-radius: 8px;
				padding: 12px;
				box-shadow: 0 2px 10px rgba(18, 123, 242, 0.08);

				&-title {
					font-size: 15px;
					font-weight: 500;
					line-height: 22px;
					margin-bottom: 6px;
					color: #333333;
				}

				&-content {
					li {
						padding-left: 12px;
						font-size: 12px;
						font-weight: 400;
						line-height: 20px;
						color: #5e6172;

						& + li {
							margin-top: 0;
						}

						&::before {
							top: 8px;
							width: 4px;
							height: 4px;
						}
					}
				}

				&-text {
					font-size: 12px;
					line-height: 18px;
				}
			}

			.timeline-item.is-future {
				.timeline-card {
					min-height: 44px;
					padding: 12px;
				}
			}
		}
	}
}
</style>
